import styled from 'styled-components';

const SectionToolbarItem = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-child) {
    margin-left: var(--spacing-s);
  }
`;

export default SectionToolbarItem;
